(function() {
	'use strict';
	var
		collapselinks = document.querySelectorAll('.collapse-btn'),
		scrollToTarget = function(buttons){
			buttons.forEach(function(button) {
				button.addEventListener("click",function(e) {
					document.querySelector(e.currentTarget.getAttribute('data-bs-target')).scrollIntoView();
				});
			});
		};

	scrollToTarget(collapselinks);
})();
